export default {
  Retro: 'retro',
  Educational: 'educational'
}